import React, { useEffect } from 'react'
import Button from '../../atoms/Button/Button'
import { Close } from '../../atoms/NewIcons'

const Modal = ({
  withoutButtons,
  CancelPlaceholder,
  ConfirmPlaceholder,
  setVisible,
  children,
  isVisible,
  withIcon,
  title,
  icon,
  subtitle,
  onConfirm,
  onClose,
  disabled,
}) => {
  useEffect(() => {}, [isVisible])

  const HeaderIcon = () => withIcon && <span className="modal__icon">{icon}</span>
  return (
    <>
      {isVisible && (
        <div className={'modal__container__fixed'}>
          <div className="modal">
            <button className="modal__close">
              <Close onClick={onClose} />
            </button>
            <div className="modal__content">
              <div className="modal__content__header">
                {withIcon && icon && <HeaderIcon />}
                {title && <p className="modal__content__header__title">{title}</p>}
                {subtitle && <p className="modal__content__header__subtitle">{subtitle}</p>}
              </div>
              {children && <div>{children}</div>}
              {!withoutButtons && (
                <div className="modal__content__actions">
                  <Button
                    disabled={disabled}
                    label={ConfirmPlaceholder ? ConfirmPlaceholder : 'Conferma e procedi'}
                    variant="primary"
                    size="large"
                    bg="#bdc2cb"
                    color="#5e6777"
                    onClick={onConfirm}
                  />
                  <Button
                    label={CancelPlaceholder ? CancelPlaceholder : 'Annulla e rimani'}
                    variant="primary"
                    size="large"
                    onClick={() => setVisible(false)}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default React.memo(Modal)
